// extracted by mini-css-extract-plugin
module.exports = {"header_for_right_menu":"rightMenu_header_for_right_menu__2t99_"};